import { render } from "./RecRequest.vue?vue&type=template&id=15023466&scoped=true&ts=true"
import script from "./RecRequest.vue?vue&type=script&lang=ts"
export * from "./RecRequest.vue?vue&type=script&lang=ts"

import "./RecRequest.vue?vue&type=style&index=0&id=15023466&scoped=true&lang=css"

import exportComponent from "d:\\jenkins-nodes\\Atlanta\\workspace\\atlanta-fe-git\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15023466"]])

export default __exports__